interface SparklineProps {
  values: number[];
  color?: string;
  width?: number;
  height?: number;
}

/** Minimal inline SVG line chart — same polyline technique as dashboard/ScoreTrend.tsx, generalized for reuse in stat cards. */
export function Sparkline({ values, color = '#4f46e5', width = 96, height = 32 }: SparklineProps) {
  if (values.length < 2) return null;

  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;

  const points = values
    .map((v, i) => {
      const x = (i / (values.length - 1)) * width;
      const y = height - ((v - min) / range) * height;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg className="gp-sparkline" viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden="true">
      <polyline points={points} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
